import React from 'react';
import { Link } from 'react-router-dom';

const services = [
  'One Way Drop Taxi',
  'Round Trip Taxi',
  'Airport Transfers',
  'Outstation Taxi Services',
  'Hill Station Tours',
  'Temple Tours',
  'City Sightseeing',
];

const Services = () => (
  <section className="services block-space" aria-labelledby="our-taxi-services-heading">
    <div className="container">
      <h2 id="our-taxi-services-heading" className="section-title">
        Our Taxi Services
      </h2>
      <ul className="taxi-service-list">
        {services.map((service) => (
          <li key={service}>
            <Link to="/services">{service}</Link>
          </li>
        ))}
      </ul>
    </div>
  </section>
);

export default Services;
